import React from 'react';
import './OverlapSection.css';

const OverlapSection = ({ layoutClass, imageUrl, mainTitle, backText }) => {

    return (
      <div className={`hero-container ${layoutClass}`}>
        
        <div className="background-area"></div>
        <div className="image-wrapper">
          <img src={imageUrl} alt="A person's face for branding" className="hero-image" />
          <div className="diagonal-overlay"></div>
        </div>
        
        <div className="text-box">
          <h1>{mainTitle}</h1>
          <p>{backText}</p>
        </div>
  
      </div>
    );
  };
export default OverlapSection;